if (!customElements.get('autoplay-video')) {
    class AutoplayVideo extends HTMLElement {

        constructor() {
            super();
            this.videoContainer = this.querySelectorAll('.autoplay-video-container');
        }

        connectedCallback() {
            this.videoContainer.forEach((video) => {
                const autoplay = video.getAttribute('data-autoplay') === 'true';
                // console.log(autoplay);
                if (!autoplay) {
                    const button = video.querySelector('.autoplay-video-play-button');
                    const videoElement = video.querySelector('video');
                    button.addEventListener('click', () => {
                        videoElement.play();
                        videoElement.setAttribute('controls', 'true');
                        button.style.display = 'none';
                    })
                }
            })
        }

    }
    customElements.define('autoplay-video', AutoplayVideo);
}